import { render, staticRenderFns } from "./OrderFormList.vue?vue&type=template&id=01cfdb70&scoped=true"
import script from "./OrderFormList.vue?vue&type=script&lang=js"
export * from "./OrderFormList.vue?vue&type=script&lang=js"
import style0 from "./OrderFormList.vue?vue&type=style&index=0&id=01cfdb70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cfdb70",
  null
  
)

export default component.exports